import React from "react";
import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Button, Card, Logo } from "../components/kit";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="buktu-root" data-testid="payment-cancel-page" style={{ minHeight: "100vh", display: "grid", placeItems: "center", background: "var(--surface-page)", padding: 24 }}>
      <Card padding="var(--space-8)" style={{ maxWidth: 460, width: "100%", textAlign: "center" }}>
        <div style={{ marginBottom: "var(--space-5)", display: "flex", justifyContent: "center" }}><Logo height={26} /></div>
        <div style={{ color: "var(--text-faint)", marginBottom: 12, display: "flex", justifyContent: "center" }}><XCircle size={44} /></div>
        <h1 style={{ font: "var(--type-heading)", marginBottom: 6 }}>Checkout canceled</h1>
        <p style={{ font: "var(--type-body-sm)", color: "var(--text-muted)", marginBottom: "var(--space-6)" }}>No charge was made. You can pick a plan whenever you're ready.</p>
        <div style={{ display: "flex", gap: "var(--space-3)" }}>
          <Button full variant="secondary" onClick={() => navigate("/pricing")}>Back to pricing</Button>
          <Button full onClick={() => navigate("/")}>Home</Button>
        </div>
      </Card>
    </div>
  );
}
